var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnotsIconNeg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 72,
    viewBox: "0 0 63 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5132 56.7549L8.32681 62.6099V72H0V22.6191H8.32681V52.4327L25.5604 36.4557H35.5443L20.6997 51.3694L36.939 72H26.817L14.5132 56.7549Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5972 38.458C60.0966 38.458 62.1403 36.4143 62.1403 33.9148V21.6939C62.1403 19.1945 60.0966 17.1507 57.5972 17.1507H44.7548H44.6305C42.2278 17.0817 40.9021 15.7698 40.8331 13.3533V13.229V4.54315C40.8331 2.04373 38.7894 0 36.2899 0H28.2255C25.7261 0 23.6823 2.04373 23.6823 4.54315V12.6076C23.6823 15.0932 25.7261 17.1507 28.2255 17.1507H36.9113H37.0356C39.4384 17.2198 40.764 18.5455 40.8331 20.9482V21.0725V33.7353C40.8331 36.3314 42.9597 38.458 45.5557 38.458H57.5972ZM21.0724 17.1646C22.5224 17.1646 23.7238 18.3521 23.7238 19.8159V25.1738C23.7238 26.6237 22.5362 27.8251 21.0724 27.8251H15.7146C14.2646 27.8251 13.0632 26.6375 13.0632 25.1738V19.8159C13.0632 18.3659 14.2508 17.1646 15.7146 17.1646H21.0724Z",
    fill: "#3441E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnotsIconNeg);
export default __webpack_public_path__ + "static/media/knots-icon-neg.ef6c5773c29d83cb49d1e4ff1244d405.svg";
export { ForwardRef as ReactComponent };